import { Injectable } from "@angular/core";
import axios from "axios";
//import moment from "moment";
import { DateTime } from 'luxon';
import { environment } from "../../../../environments/environment";
import { CalculatorSettingsService } from "../calculatorsettings/calculator-settings.service";
import { PiBootstrapService } from "../pi-builder/pi-bootstrap.service";

export const QUOTER_RFF_2025_ENDDATE = "12/31/2025";

@Injectable({
    providedIn: "root"
})
export class FormulateDates2Service {
    currentDate: Date;
    rffGoLiveDate: Date;
    services: number[] = [2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027];

    /*
    constructor(
        private calculatorSettingsService: CalculatorSettingsService,
        private piBootstrapService: PiBootstrapService
    ) {
        this.currentDate = moment().toDate();
        this.piBootstrapService.current(this.currentDate);

        if (window["CurrentDate"]) {
            this.currentDate = new Date(window["CurrentDate"]);
            this.piBootstrapService.current(this.currentDate);
        }

        if (window["RffGoLiveDate"]) {
            this.rffGoLiveDate = new Date(window["RffGoLiveDate"]);
        }

        this.queryForYear();
    }
    */

    
    constructor(
        private calculatorSettingsService: CalculatorSettingsService,
        private piBootstrapService: PiBootstrapService
    ) {
        this.currentDate = DateTime.now().toJSDate();
        this.piBootstrapService.current(this.currentDate);

        if (window["CurrentDate"]) {
            this.currentDate = new Date(window["CurrentDate"]);
            this.piBootstrapService.current(this.currentDate);
        }

        if (window["RffGoLiveDate"]) {
            this.rffGoLiveDate = new Date(window["RffGoLiveDate"]);
        }

        this.queryForYear();
    }
    
    /*
    getMinStartDate() {
        const dtm = moment(this.getCurrentDate());
        if (this.calculatorSettingsService.IsAgentOrPro()) {
            return dtm.add(-1, 'y');
        }
        else {
            return dtm.add(-125, 'd');
        }
    }
    */

    
    getMinStartDate() {
        const dtm = DateTime.fromJSDate(this.getCurrentDate());
        if (this.calculatorSettingsService.IsAgentOrPro()) {
            return dtm.minus({ years: 1 });
        }
        else {
            return dtm.minus({ days: 125 });
        }
    }
    
    /*
    getDateCalc(dt: Date, isAgent: boolean) {
        const dtm = moment(dt).startOf('day');
        if (isAgent) {
            return dtm.add(-1, 'y');
            //return dtm.isLeapYear() ? dtm.add(-1, 'y').add(-1, 'd') : dtm.add(-1, 'y');
        }
        else {
            return dtm.add(-125, 'd');
        }
    }
    */

    
    getDateCalc(dt: Date, isAgent: boolean) {
        const dtm = DateTime.fromJSDate(dt).startOf('day');
        if (isAgent) {
            return dtm.minus({ years: 1 });
            //return dtm.isLeapYear() ? dtm.add(-1, 'y').add(-1, 'd') : dtm.add(-1, 'y');
        }
        else {
            return dtm.minus({ days: 125 });
        }
    }
    
    /*
    getMaxStartDate() {
        const service = this.getLatestServiceYear(this.currentDate);
        return moment(service.endDate, "MM/DD/YYYY");
    }
    */


    getMaxStartDate() {
        const service = this.getLatestServiceYear(this.currentDate);
        return DateTime.fromFormat(service.endDate, "MM/dd/yyyy");
    }
    
    /*
    getCurrentDate() {
        return moment(this.currentDate).startOf('day').toDate();
    }
    */

    
    getCurrentDate() {
        return DateTime.fromJSDate(this.currentDate).startOf('day').toJSDate();
    }
    
    /*
    queryForYear() {
        let timerurl = environment.apiUrl + environment.timerurl;
        if (window["spaSourceUrl"]) {
            timerurl = window["spaSourceUrl"] + environment.timerurl;
        }

        return new Promise((resolve, reject) => {
            axios({
                method: "get",
                url: timerurl,
                headers: {
                    "Content-Type": "application/json"
                },
            }).then((res) => {
                this.currentDate = res.data[0] ? new Date(res.data[0]) : moment().toDate();
                this.piBootstrapService.current(this.currentDate);
                if (res.data[1] && res.data[1] != null) {
                    this.rffGoLiveDate = new Date(res.data[1]);
                }
            }).catch(error => {
                //will use default values commented
            });
        });
    }
    */

    
    queryForYear() {
        let timerurl = environment.apiUrl + environment.timerurl;
        if (window["spaSourceUrl"]) {
            timerurl = window["spaSourceUrl"] + environment.timerurl;
        }

        return new Promise((resolve, reject) => {
            axios({
                method: "get",
                url: timerurl,
                headers: {
                    "Content-Type": "application/json"
                },
            }).then((res) => {
                this.currentDate = res.data[0] ? new Date(res.data[0]) : DateTime.now().toJSDate();
                this.piBootstrapService.current(this.currentDate);
                if (res.data[1] && res.data[1] != null) {
                    this.rffGoLiveDate = new Date(res.data[1]);
                }
            }).catch(error => {
                //will use default values commented
            });
        });
    }
    
    /*
    toDate(dt: Date | moment.Moment): Date {
        let cdt = moment.isMoment(dt) ? dt.toDate() : dt instanceof Date ? dt : new Date(dt);
        cdt.setHours(0, 0, 0, 0);

        return cdt;
    }
    */


    toDate(dt: Date | DateTime): Date {
        const cdt = dt instanceof DateTime ? dt.toJSDate() : dt instanceof Date ? dt : DateTime.fromFormat(dt, "MM/dd/yyyy").toJSDate();
        cdt.setHours(0, 0, 0, 0);

        return cdt;
    }
    

    /*
    getService(dt: any) {
        let dtm = moment(dt, "MM/DD/YYYY");

        return this.getServiceVariables(dtm.year());
    }
    */

    
    getService(dt: any) {
        const dtm = DateTime.fromFormat(dt, "MM/dd/yyyy");

        return this.getServiceVariables(dtm.year);
    }
    

    getServiceVariables(year: number) {
        const name = "quoter" + year.toString() + "Service";
        const env = environment[name];

        return env;
    }

    getLatestServiceYear(dt: Date) {
        //check all services and return the last service year enabled
        for (let i = 0; i < this.services.length; i++) {
            const service = this.getServiceVariables(this.services[i]);
            if (dt.getTime() < new Date(service.dateToEnableRates).getTime()) {
                return (i > 0) ? this.getServiceVariables(this.services[i - 1]) : this.getServiceVariables(this.services[0]);
            }
        }

        return this.getServiceVariables(this.services[this.services.length - 1]);
    }

    getMode() {
        if (this.calculatorSettingsService.IsAgentOrPro()) {
            return "Agent";
        }

        return "Consumer";
    }

}
